import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import {
  createSettingsParams, type ISettingsParam,
  type PartialBy
} from '@wix/tpa-settings';
import { AlignmentOptions, LayoutOptions } from '../../types/types';
import { AccessibilityHtmlTags } from '../../utils/accessibility/constants';
import calendarSettingsParams, { booleanSettingsParam, enumSettingsParam, settingsParam, settingsParamWithMobileDefault, textSettingsParam, type ISettingsParams } from '../BookingCalendar/settingsParams';

type WeeklyTimetableSettingsOverride = Pick<
  ISettingsParams,
  | 'calendarLayout'
  | 'textAlignment'
  | 'headerTitleHtmlTag'
  | 'headerServiceFilterVisibility'
  | 'headerStaffFilterVisibility'
  | 'headerLocationFilterVisibility'
  | 'headerTimezoneSelectionVisibility'
  | 'headerSubtitleVisibility'
  | 'limitTimeSlotsDisplay'
  | 'maxTimeSlotsDisplayedPerDay'
  | 'noSessionsOffered'
  | 'loadMoreTimeSlots'
  | 'nextButton'
>;

export type IWeeklyTimetableSettingsDefinitions = {
  [key in keyof WeeklyTimetableSettingsOverride]: PartialBy<
    ISettingsParam<WeeklyTimetableSettingsOverride[key]>,
    'key'
  >;
};

export const weeklyTimetableSettingsParamsDefinitions: IWeeklyTimetableSettingsDefinitions =
{
  calendarLayout: settingsParamWithMobileDefault(DataType.textEnum, LayoutOptions.WEEKLY_TIMETABLE, LayoutOptions.DAILY_AGENDA_WEEKLY_PICKER),
  textAlignment: enumSettingsParam(AlignmentOptions.CENTER),
  headerTitleHtmlTag: enumSettingsParam(AccessibilityHtmlTags.SecondaryHeading),
  headerServiceFilterVisibility: booleanSettingsParam(true),
  headerStaffFilterVisibility: booleanSettingsParam(true),
  headerLocationFilterVisibility: booleanSettingsParam(false),
  headerTimezoneSelectionVisibility: booleanSettingsParam(false),
  headerSubtitleVisibility: booleanSettingsParam(false),
  maxTimeSlotsDisplayedPerDay: settingsParam(DataType.number, 1),
  limitTimeSlotsDisplay: settingsParamWithMobileDefault(DataType.booleanValue, false, true),
  noSessionsOffered: textSettingsParam('app.settings.defaults.slots.no-availability'),
  loadMoreTimeSlots: textSettingsParam('app.settings.defaults.time-picker.daily-agenda.show-all'),
  nextButton: textSettingsParam('app.settings.defaults.button.book'),
};

const weeklyTimetableSettingsParams =
  createSettingsParams<WeeklyTimetableSettingsOverride>(
    weeklyTimetableSettingsParamsDefinitions,
  );

export default {
  ...calendarSettingsParams,
  ...weeklyTimetableSettingsParams,
};
